import { orderBy } from 'lodash';

import type { CustomToneOfVoice } from './types';

export const sortCustomToneOfVoice = (items: CustomToneOfVoice[]): CustomToneOfVoice[] =>
  orderBy(items, ['isDefault', 'updatedAt', 'name', 'id'], ['desc', 'desc', 'asc', 'asc']);
